<template>
  <b-container class="main-container">
    <div v-if="post && post.content">
      <b-row>
        <b-col>
          <router-link class="read-all" to="/blog"> &lt; all posts</router-link>
        </b-col>
        <b-col>
          <p class="post-title">{{ post.title }}</p>
        </b-col>
        <b-col></b-col>
      </b-row>
      <b-row class="desc-row">
        <b-col class="author-col">
          <p>Written By: {{ post.author }}</p>
        </b-col>
        <b-col class="date-col">
          <p>{{ post.date | formatDate }}</p>
        </b-col>
      </b-row>
      <div class="blog-container">
        <b-row>
          <b-col>
            <vue-markdown class="markdown-text" :source="post.content" />
          </b-col>
        </b-row>
      </div>
    </div>
  </b-container>
</template>

<script>
import VueMarkdown from 'vue-markdown-render';
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
    'vue-markdown': VueMarkdown
  },
  data() {
    return {
      id: null
    };
  },
  computed: {
    ...mapGetters('blog', ['blogPostById', 'blogPosts']),
    post() {
      return this.blogPostById(this.id);
    }
  },
  methods: {
    ...mapActions('blog', ['fetchBlogPostContent', 'fetchBlogPosts']),

    goToFullBlogPost() {
      this.$router.push({
        name: 'full',
        params: {
          id: this.post.id,
          data: { post: this.post, content: this.content }
        }
      });
    }
  },
  async created() {
    this.id = this.$route.params.id;
    if (this.blogPosts.length === 0) {
      await this.fetchBlogPosts();
      await this.fetchBlogPostContent(this.id);
    }
  },
  mounted() {}
};
</script>

<style scoped>
.main-container {
  margin-top: 3rem;
  height: fit-content;
}
.blog-container {
  border-top: none;
  padding: 1rem;
  position: relative;
}

.post-title {
  font-weight: bold;
  font-size: 32px;
  color: rgb(12, 192, 150);
}

.no-margin {
  margin: 0;
}

.author-col {
  text-align: left;
}

.date-col {
  text-align: right;
}

.desc-row {
  padding: 0 1.5rem 0 1.5rem;
  font-weight: bold;
  color: gray;
}

.read-all {
  color: rgb(12, 192, 150);
  font-size: 18px;
  text-align: left;
  position: absolute;
  left: 35px;
}

.markdown-text {
  text-align: left;
}
</style>
